export default [
  {
    title: `Sobre a JUVO`,
    text: `Desde 2018 a missão da JUVO é oferecer oportunidades financeiras e democratizar o acesso ao crédito com taxa de juros mais baixas, auxiliando autônomos sem comprovação de renda.`,
  },
  {
    title: `Como funciona o empréstimo pessoal com a JUVO?`,
    text: `
    <ul>
      <li>Dinheiro na conta em até 1 dia útil.</li>
      <li>Aceita pessoas de 22 a 67 anos.</li>
      <li>Aceita autônomos.</li>
      <li>Sem comprovação de renda.</li>
    </ul>
    `,
  },
  {
    title: `Quais são as etapas de solicitação?`,
    text: `É super simples!
      <ol>
        <li>Após clicar em “Simular”</li>
        <li>Você será redirecionado para baixar o app da JUVO onde será preciso preencher alguns dados iniciais</li>
        <li>Após preencher seus dados e adicionar a conta bancária para depósito você irá realizar uma foto do seu rosto como assinatura</li>
        <li>Depois deve enviar seu documento RG para comprovação</li>
        <li>Por fim, é só aguardar a análise e receber o dinheiro em até 1 dia útil</li>
      </ol>
    `,
  },
  {
    title: `Qual a documentação necessária para contratar?`,
    text: `Apenas o RG.`,
  },
  {
    title: `Quais são os requisitos para pedir um empréstimo?`,
    text: `Você precisa ter um CPF válido, a partir de 22 anos e seguir com as orientações da contratação no site da parceira.`,
  },
  {
    title: `Em quanto tempo vou receber o dinheiro na minha conta bancária?`,
    text: `O prazo para pagamento é de 1 dia útil após a aprovação da sua oferta.`,
  },
]
